import "./execute.css";
import { useEffect } from "react";
import apiLink from "../../api/apiLink";
import { useSelector } from "react-redux";
import TdLoader from "../../components/common/TdLoader";

export default function ShurjoPayExecute() {
  const urlParams = new URLSearchParams(window.location.search);
  const orderID = urlParams.get("order_id");

  const userData = useSelector(
    (state) => state.persistedReducer.auth?.currentUser?.customer,
  );

  const paymentExecute = async () => {
    let URL = {
      execute: "customer/shurjoPay/payment/execute",
      baseURL: apiLink,
    };

    const ispOwnerId = userData
      ? userData.ispOwner.id
      : sessionStorage.getItem("qrispid");

    return await URL.baseURL.post(`${URL.execute}?orderID=${orderID}`, {
      ispOwner: ispOwnerId,
    });
  };

  useEffect(() => {
    paymentExecute()
      .then((response) => {
        if (response?.data?.bill?.paymentStatus === "paid") {
          sessionStorage.removeItem("qrispid");
          window.location.href = "/payment/success";
        } else if (response?.data?.resellerRecharge?.paymentStatus === "paid") {
          sessionStorage.removeItem("qrispid");
          window.location.href = "/payment/success";
        } else {
          sessionStorage.removeItem("qrispid");
          window.location.href = "/payment/failed";
        }
      })
      .catch((err) => {
        sessionStorage.removeItem("qrispid");
        window.location.href = "/payment/failed";
      });
  }, []);

  return (
    <div className="payment-loading-overlay">
      <div className="payment-loading-content">
        <TdLoader />

        <h5 className="mt-3">Payment Processing…</h5>

        <p className="text-center small mt-1">
          Please wait while we securely complete your payment. <br />
          Do not refresh or close this page.
        </p>
      </div>
    </div>
  );
}
